module.exports = __webpack_public_path__ + "static/media/clearSearch.3a2085b3.svg";